<template>
  <div>
    <div v-if="loaded">
      <IsVip v-if="vipInfo" :userInfo="userInfo" :vipInfo="vipInfo"></IsVip>
      <UpdataApp v-else />
      <!-- <NotVip v-else :userInfo="userInfo"></NotVip> -->
    </div>
    <AppLoading v-else class="loading"></AppLoading>
  </div>
</template>
<script>
import AppLoading from '@/components/app/loading/loading.vue'
import NotVip from './components/not-vip.vue'
import UpdataApp from './components/update-app.vue'
import IsVip from './components/is-vip.vue'
export default {
  name: 'betterwe-vip',
  components: {
    NotVip,
    IsVip,
    AppLoading,
    UpdataApp
  },
  data() {
    return {
      vipInfo: null,
      userInfo: null,
      loaded: false
    }
  },
  created() {
    this.getInfo()
    this.$betterwe.checkAppUpdate(38)
  },
  mounted() {
    this.$buryPoint('BG_VIPBUY', {})
    this.addLog('大会员页曝光')
  },
  methods: {
    /**
     * 埋点
     */
    addLog(from) {
      this.$http
        .getApp('member/StorageLogin/spotLog', { from, type: 3 })
        .then((res) => {})
    },
    addEventUserInfo() {
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.timer = setInterval(async () => {
        let res = await this.$http
          .getApp('api/v1/WeplusUserCenter/getUserInfo', {})
          .catch(() => {})
        res = res?.data
        if (
          res.data.card_type_info &&
          res.data.card_type_info.card_type_second_level
        ) {
          return
        }
        if (res && res.code == 200 && res.data.card_info) {
          if (res.data.card_type_info) {
            res.data.card_info.type_id = res.data.card_type_info.type_id
          }
          this.vipInfo = res.data.card_info
          this.userInfo = res.data.user_info
          clearInterval(this.timer)
        }
      }, 1500)
    },
    getInfo() {
      this.$http
        .getApp('api/v1/WeplusUserCenter/getUserInfo', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (
              res.data.card_type_info &&
              res.data.card_type_info.card_type_second_level
            ) {
              return
            }
            if (res.data.card_type_info) {
              res.data.card_info.type_id = res.data.card_type_info.type_id
            }
            this.vipInfo = res.data.card_info
            this.userInfo = res.data.user_info
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
          this.$toast('异常错误')
        })
        .finally(() => {
          this.loaded = true
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.loading {
  padding-top: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
